<nb-card class="dialog-show-location">
    <nb-card-header>Last Tracked Location</nb-card-header>
    <nb-card-body>
        <agm-map 
          [latitude]="latitude"
          [longitude]="longitude"
          [zoom]="zoom"
          [disableDefaultUI]="false"
          [mapTypeControl]='true'
          [fullscreenControl]="true"
          [streetViewControl]="false"
          (mapReady)="onMapLoad($event)"
        >
        <agm-marker
            [latitude]="device.marker.lat" 
            [longitude]="device.marker.lng" 
            [iconUrl]="{'url': device.marker.imgPin,'scaledSize': {'height': 84, 'width': 84},'anchor': {'x': 42, 'y': 42}}"
            (markerClick)="clickedMarker(infoWindow)"
          >
            <agm-info-window [isOpen]="false" [latitude]="device.marker.lat" [longitude]="device.marker.lng" #infoWindow>
                  <div class="infoContent" >
                    <p class="infoName" ><strong>{{ device.name }}</strong></p>
                    <p class="infoDevice">({{ device.device }})</p>
                    <div>
                        <p class="pindatetime"><strong>Date/Time:</strong> {{ device.marker.created}}</p>
                        <br>
                        <p class="pininfoaddress">
                          <strong>{{ placeTitle }}</strong>
                          <br>
                          <span *ngFor="let address of currentAddress">
                            {{ address }}
                          </span>
                          <br>
                          <a
                            class="map-link"
                            target="_blank"
                            [href]="placeId 
                              ? 'https://www.google.com/maps/place/?q=place_id:' + placeId 
                              : 'https://www.google.com/maps?q=' + device.marker.lat + ',' + device.marker.lng">
                            View on Google Maps
                          </a>
                        </p>
                    </div>
                  </div>
              </agm-info-window>
          </agm-marker>
          
        </agm-map>
    </nb-card-body>
    <nb-card-footer>
        <button class="cancel" nbButton matRipple status="danger" (click)="close()">Close</button>
    </nb-card-footer>
</nb-card>